import React from 'react';

import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';
import UnderlinedText from '@marketing/components/underlined_text';

import AnalyticsFeature from './assets/analytics_feature.png';
import PracticeTestsFeature from './assets/practice_tests_feature.png';
import ScorePredictorFeature from './assets/score_predictor_feature.png';
import StarIcon from './assets/star_icon.svg';
import StudentHelpFeature from './assets/student_help_feature.png';
import StudySchedulesFeature from './assets/study_schedules_feature.png';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l">
      <SectionHeader
        supertitle="Features"
        supertitleIcon={StarIcon}
        title="More proof we're the best deal in ACT prep"
      />

      <div className="d-flex flex-column gap-m">
        <div className="d-flex flex-column flex-lg-row gap-m">
          <Card
            style={{
              background: 'linear-gradient(225deg, #FAFAFA, #FAFAFA 30%, #FFFFFF)',
              gap: 0,
              padding: 0
            }}
          >
            <div>
              <img
                alt="Examples of a practice test score report"
                loading="lazy"
                src={PracticeTestsFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s" style={{ padding: 20, paddingTop: 0 }}>
              <div className="text-bold text-inter">
                Full Length Practice Tests
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                11 full-length official ACT practice tests.
              </div>
            </div>
          </Card>

          <Card
            style={{
              background: 'linear-gradient(225deg, #FAFAFA, #FAFAFA 30%, #FFFFFF)',
              gap: 0,
              padding: 0
            }}
          >
            <div>
              <img
                alt="Estimated score and stats for questions answered and pace"
                loading="lazy"
                src={ScorePredictorFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s" style={{ padding: 20, paddingTop: 0 }}>
              <div className="text-bold text-inter">
                Score Predictor
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Check your predicted ACT score anytime, based on your current progress.
              </div>
            </div>
          </Card>
        </div>

        <div className="d-flex flex-column flex-lg-row gap-m">
          <Card
            style={{
              background: 'linear-gradient(225deg, #FAFAFA, #FAFAFA 30%, #FFFFFF)',
              padding: 0
            }}
          >
            <div>
              <img
                alt="Quick AI help, and help from a real human when you really need it"
                loading="lazy"
                src={StudentHelpFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s" style={{ padding: 20, paddingTop: 0 }}>
              <div className="text-bold text-inter">
                Get Help from a Real Human
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Hit a tough question? Email us, and our experts will help you break it down.
              </div>
            </div>
          </Card>

          <Card
            style={{
              background: 'linear-gradient(225deg, #FAFAFA, #FAFAFA 30%, #FFFFFF)',
              gap: 0,
              padding: 0
            }}
          >
            <div>
              <img
                alt="Some of the flexible study schedules you can choose"
                loading="lazy"
                src={StudySchedulesFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s" style={{ padding: 20, paddingTop: 0 }}>
              <div className="text-bold text-inter">
                Flexible Study Schedules
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Follow expert-made study plans tailored to your timeline and experience... or set your own pace.
              </div>
            </div>
          </Card>

          <Card
            style={{
              background: 'linear-gradient(225deg, #FAFAFA, #FAFAFA 30%, #FFFFFF)',
              padding: 0
            }}
          >
            <div>
              <img
                alt="Charts and graphs showing your progress, strengths, and weaknesses"
                loading="lazy"
                src={AnalyticsFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s" style={{ padding: 20, paddingTop: 0 }}>
              <div className="text-bold text-inter">
                Personalized Analytics
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                See which ACT sections matter most, how you're doing in each, and how you're improving.
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
